export default {
  "ask-quote": "Demander un devis",
  "department-action": "Départements d'action",
  "not-specified": "Non renseigné",
  about: {
    "company-values": "Valeurs de l'entreprise",
    subtitle: "À propos de",
  },
  documents: {
    title: "Nos documents officiels",
    insurance: "Assurance",
  },
  department: {
    hero: {
      "service-page-header": {
        verified: "Entreprise vérifiée",
        certification: "Certification",
      },
    },
  },
  profile: {
    header: {
      title: "Profil de l'installateur",
      subtitle: "Vous trouverez ci-dessous toutes les informations concernant l'installateur",
    },
    "book-appointment": "Prenez votre rendez-vous",
    about: "À propos",
    "all-about": "Tout savoir sur",
    "head-office": "Siège social",
    hire: "Engager installateur",
    "founded-date": "Date de fondation",
    employees: "Employés",
    departments: "Départements",
  },
}
